export default __webpack_public_path__ + "static/logo-f55efd43317292a63f47d2bbdbbfd344.png";